import RouterSection from '@/components/layout/RouterSection'

export default {
    path: '/main',
    name: 'main-index',
    component: RouterSection,
    children: [
        {
            path: '/main',
            name: 'main-main-index',
            component: () => import('@/views/main/Main.vue')
        },
        {
            path: '/dashboard',
            name: 'dashboard-index',
            component: () => import('@/views/main/Dashboard.vue')
        },
        {
            path: '/duedate',
            name: 'duedate-index',
            component: () => import('@/views/main/Duedate.vue')
        },
        {
            path: '/notification',
            name: 'notification-index',
            component: () => import('@/views/main/Notification.vue')
        }
    ]
}